import { Box } from '@mui/material';
import { UseEmblaCarouselType } from 'embla-carousel-react';
import React from 'react';
import { ECarouselVariant } from '../types';

type Props = {
  url: string;
  isVideo: boolean;
  variant?: ECarouselVariant;
  className?: string;
  lazyLoading?: boolean;
  emblaApi?: UseEmblaCarouselType[1];
  style: React.CSSProperties;
};

export default function Slide({ url, isVideo, className, emblaApi, style }: Props) {
  return (
    <>
      {isVideo ? (
        <Box
          className={className}
          component="video"
          src={url}
          autoPlay
          muted
          playsInline
          preload="auto"
          width="100%"
          height="100%"
          onPlay={() => {
            emblaApi?.plugins()?.autoplay.stop();
          }}
          onEnded={(e) => {
            emblaApi?.scrollNext();
            emblaApi?.plugins()?.autoplay.play();
            // reset video
            e.currentTarget.currentTime = 0;
          }}
          sx={{
            flex: '0 0 100%',
            minWidth: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            ...style,
          }}
        />
      ) : (
        <img
          src={url}
          style={{
            flex: '0 0 100%',
            minWidth: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            ...style,
          }}
          alt="gallery slide"
          draggable={false}
        />
      )}
    </>
  );
}
